export enum TableColumnKey {
  SettlementDate = 'settlementDate',
  DistributorAgentId = 'distributorAgentId',
  DistributorAgentName = 'distributorAgentName',
  ProgramName = 'programName',
  Repayment = 'repayment',
  TotalTransactionAmount = 'totalTxAmount',
  Payment = 'payment',
  PaMarkup = 'paMarkup',
  AnnualFee = 'annualFee',
  VisaRebate = 'visaRebate',
  PaRebate = 'paRebate',
  TotalAgentInterest = 'totalAgentInterest',
}

export interface TableRow {
  id: number;
  [TableColumnKey.SettlementDate]: string;
  [TableColumnKey.DistributorAgentId]: string;
  [TableColumnKey.DistributorAgentName]: string;
  [TableColumnKey.ProgramName]: string;
  [TableColumnKey.Repayment]: string;
  [TableColumnKey.TotalTransactionAmount]: string;
  [TableColumnKey.Payment]: string;
  [TableColumnKey.PaMarkup]: string;
  [TableColumnKey.AnnualFee]: string;
  [TableColumnKey.VisaRebate]: string;
  [TableColumnKey.PaRebate]: string;
  [TableColumnKey.TotalAgentInterest]: string;
  rawData: any;
}
